import { Component, OnInit } from "@angular/core";
import { JobLogDto } from "app/models";
import { LogsService } from "app/services/logs.service";

@Component({
    selector: 'admin-job-logs',
    templateUrl: 'admin-job-logs.page.html',
    styleUrls: ['../../../layouts/admin/admin.layout.scss', 'admin-job-logs.page.scss'],
})
export class AdminJobLogsPage implements OnInit {
    
    data: JobLogDto[];

    constructor(private logService: LogsService) {

    }
    
    ngOnInit(): void {
        this.loadData();
    }

    private loadData() {
        this.logService.getLatestJobLogs()
            .subscribe(result => {
                this.data = result;
                console.log(this.data);
            })
    }
}